<template>
    <div class="container__">
        <div class="exam__page">

            <!-- Content -->
            <div class="content__exam" id="scrolla" :class="{'prt': !typeFull}">
                <div :class="{'content__exam_t': !typeFull}" id="scroll">
                    <template v-for="(item, index) in questions">
                        <div class="question__" :key="index" v-show="typeFull || (!typeFull && activeID == item.id)" :id="'question__' + item.num">
                            <div class="question__brd" :class="[{activeQuesion: item.id == activeID}, {_isCommit: item.commitFlag}]">

                                <!-- Number question -->
                                <div class="question__count">
                                    <span>{{$t('task_result.question')}} {{item.num}}:</span>
                                </div>

                                <!-- List preview -->
                                <div class="question__end" @click="item.checkFlag = item.checkFlag == 0 ? 1 : 0">
                                    <span>{{$t('new.title127')}}</span>
                                    <img class="preview_question" v-if="item.checkFlag == 0" src="/static/images/checkCircleBlack.png" alt="check">
                                    <img class="preview_question" v-else src="/static/images/checkCircleBlue.png" alt="check">
                                </div>
                            </div>
                            <!-- Question: content -->
                            <div class="question__content">

                                <!-- Content: normal -->
                                <div class="nd__u" v-html="item.content"></div>

                                <!-- Content: Audio -->
                                <audio v-if="checkedAudio(item.audioName)" controls="controls" :src="item.audioPath" controlsList="nodownload" oncontextmenu=" return false" class="audio"></audio>

                                <!-- Content: Video -->
                                <video v-if="checkedVideo(item.audioName)" :src="item.audioPath" controls="controls" controlsList="nodownload" class="video"></video>

                                <!-- Type: 1 - radio -->
                                <div class="content__answer__radio" v-if="parseInt(item.type) == 1">
                                    <p v-if="item.optionA">
                                        <input v-model="item.answer" :id="'radio_a_' + item.id" :name="'radio_a_' + item.id" type="radio" class="radio-group" value="A" @change="changeQuestion(item, 'question__' + item.num, null, false)" />
                                        <label :for="'radio_a_' + item.id" v-html="item.optionA"></label>
                                    </p>
                                    <p v-if="item.optionB">
                                        <input v-model="item.answer" :id="'radio_b_' + item.id" :name="'radio_b_' + item.id" type="radio" class="radio-group" value="B" @change="changeQuestion(item, 'question__' + item.num, null, false)" />
                                        <label :for="'radio_b_' + item.id" v-html="item.optionB"></label>
                                    </p>
                                    <p v-if="item.optionC">
                                        <input v-model="item.answer" :id="'radio_c_' + item.id" :name="'radio_c_' + item.id" type="radio" class="radio-group" value="C" @change="changeQuestion(item, 'question__' + item.num, null, false)" />
                                        <label :for="'radio_c_' + item.id" v-html="item.optionC"> </label>
                                    </p>
                                    <p v-if="item.optionD">
                                        <input v-model="item.answer" :id="'radio_d_' + item.id" :name="'radio_d_' + item.id" type="radio" class="radio-group" value="D" @change="changeQuestion(item, 'question__' + item.num, null, false)" />
                                        <label :for="'radio_d_' + item.id" v-html="item.optionD"></label>
                                    </p>
                                    <p v-if="item.optionE">
                                        <input v-model="item.answer" :id="'radio_e_' + item.id" :name="'radio_e_' + item.id" type="radio" class="radio-group" value="E" @change="changeQuestion(item, 'question__' + item.num, null, false)" />
                                        <label :for="'radio_e_' + item.id" v-html="item.optionE"></label>
                                    </p>
                                    <p v-if="item.optionF">
                                        <input v-model="item.answer" :id="'radio_f_' + item.id" :name="'radio_f_' + item.id" type="radio" class="radio-group" value="F" @change="changeQuestion(item, 'question__' + item.num, null, false)" />
                                        <label :for="'radio_f_' + item.id" v-html="item.optionF"></label>
                                    </p>
                                    <p v-if="item.optionG">
                                        <input v-model="item.answer" :id="'radio_g_' + item.id" :name="'radio_g_' + item.id" type="radio" class="radio-group" value="G" @change="changeQuestion(item, 'question__' + item.num, null, false)" />
                                        <label :for="'radio_g_' + item.id" v-html="item.optionG"></label>
                                    </p>
                                    <p v-if="item.optionH">
                                        <input v-model="item.answer" :id="'radio_h_' + item.id" :name="'radio_h_' + item.id" type="radio" class="radio-group" value="H" @change="changeQuestion(item, 'question__' + item.num, null, false)" />
                                        <label :for="'radio_h_' + item.id" v-html="item.optionH"></label>
                                    </p>
                                    <p v-if="item.optionI">
                                        <input v-model="item.answer" :id="'radio_i_' + item.id" :name="'radio_i_' + item.id" type="radio" class="radio-group" value="I" @change="changeQuestion(item, 'question__' + item.num, null, false)" />
                                        <label :for="'radio_i_' + item.id" v-html="item.optionI"></label>
                                    </p>
                                    <p v-if="item.optionJ">
                                        <input v-model="item.answer" :id="'radio_j_' + item.id" :name="'radio_j_' + item.id" type="radio" class="radio-group" value="J" @change="changeQuestion(item, 'question__' + item.num, null, false)" />
                                        <label :for="'radio_j_' + item.id" v-html="item.optionJ"></label>
                                    </p>
                                </div>

                                <!-- Type: 2 - check box -->
                                <div class="content__answer__check__box" v-if="parseInt(item.type) == 2">
                                    <p v-if="item.optionA">
                                        <input v-model="item.answer" :id="'checkbox_a_' + item.id" :name="'checkbox_a_' + item.id" type="checkbox" class="radio-group" value="A" @change="changeQuestion(item, 'question__' + item.num, null)" />
                                        <label :for="'checkbox_a_' + item.id" v-html="item.optionA"></label>
                                    </p>
                                    <p v-if="item.optionB">
                                        <input v-model="item.answer" :id="'checkbox_b_' + item.id" :name="'checkbox_b_' + item.id" type="checkbox" class="radio-group" value="B" @change="changeQuestion(item, 'question__' + item.num, null)" />
                                        <label :for="'checkbox_b_' + item.id" v-html="item.optionB"></label>
                                    </p>
                                    <p v-if="item.optionC">
                                        <input v-model="item.answer" :id="'checkbox_c_' + item.id" :name="'checkbox_c_' + item.id" type="checkbox" class="radio-group" value="C" @change="changeQuestion(item, 'question__' + item.num, null)" />
                                        <label :for="'checkbox_c_' + item.id" v-html="item.optionC"> </label>
                                    </p>
                                    <p v-if="item.optionD">
                                        <input v-model="item.answer" :id="'checkbox_d_' + item.id" :name="'checkbox_d_' + item.id" type="checkbox" class="radio-group" value="D" @change="changeQuestion(item, 'question__' + item.num, null)" />
                                        <label :for="'checkbox_d_' + item.id" v-html="item.optionD"></label>
                                    </p>
                                    <p v-if="item.optionE">
                                        <input v-model="item.answer" :id="'checkbox_e_' + item.id" :name="'checkbox_e_' + item.id" type="checkbox" class="radio-group" value="E" @change="changeQuestion(item, 'question__' + item.num, null)" />
                                        <label :for="'checkbox_e_' + item.id" v-html="item.optionE"></label>
                                    </p>
                                    <p v-if="item.optionF">
                                        <input v-model="item.answer" :id="'checkbox_f_' + item.id" :name="'checkbox_f_' + item.id" type="checkbox" class="radio-group" value="F" @change="changeQuestion(item, 'question__' + item.num, null)" />
                                        <label :for="'checkbox_f_' + item.id" v-html="item.optionF"></label>
                                    </p>
                                    <p v-if="item.optionG">
                                        <input v-model="item.answer" :id="'checkbox_g_' + item.id" :name="'checkbox_g_' + item.id" type="checkbox" class="radio-group" value="G" @change="changeQuestion(item, 'question__' + item.num, null)" />
                                        <label :for="'checkbox_g_' + item.id" v-html="item.optionG"></label>
                                    </p>
                                    <p v-if="item.optionH">
                                        <input v-model="item.answer" :id="'checkbox_h_' + item.id" :name="'checkbox_h_' + item.id" type="checkbox" class="radio-group" value="H" @change="changeQuestion(item, 'question__' + item.num, null)" />
                                        <label :for="'checkbox_h_' + item.id" v-html="item.optionH"></label>
                                    </p>
                                    <p v-if="item.optionI">
                                        <input v-model="item.answer" :id="'checkbox_i_' + item.id" :name="'checkbox_i_' + item.id" type="checkbox" class="radio-group" value="I" @change="changeQuestion(item, 'question__' + item.num, null)" />
                                        <label :for="'checkbox_i_' + item.id" v-html="item.optionI"></label>
                                    </p>
                                    <p v-if="item.optionJ">
                                        <input v-model="item.answer" :id="'checkbox_j_' + item.id" :name="'checkbox_j_' + item.id" type="checkbox" class="radio-group" value="J" @change="changeQuestion(item, 'question__' + item.num, null)" />
                                        <label :for="'checkbox_j_' + item.id" v-html="item.optionJ"></label>
                                    </p>
                                </div>

                                <!-- Type: 3 - text area -->
                                <div class="content__answer__textarea" v-if="parseInt(item.type) == 3">
                                    <textarea v-model="item.answer" spellcheck="false" @input="changeQuestion(item, 'question__' + item.num, null, false)" :placeholder="$t('questionnaire.contentInput')"></textarea>
                                </div>

                                <!-- Type: 4 - paragraph -->
                                <div class="content__answer__plus" v-if="parseInt(item.type) == 4">
                                    <template v-for="(itemMini, indexMini) in item.miniQuestions">
                                        <div class="content__answer__plus__question radio_ja" :key="indexMini">
                                            <div v-html="itemMini.content"></div>
                                            <!-- Đáp án: Radio -->
                                            <div class="content__answer__radio" :key="indexMini">
                                                <p v-if="itemMini.optionA" class="radio_ja_p">
                                                    <input v-model="itemMini.answer" :id="'mini_radio_a_' + itemMini.id" type="radio" class="radio-group" value="A" @change="changeQuestion(item, 'question__' + item.num, indexMini, false)" />
                                                    <label :for="'mini_radio_a_' + itemMini.id" v-html="itemMini.optionA"></label>
                                                </p>
                                                <p v-if="itemMini.optionB" class="radio_ja_p">
                                                    <input v-model="itemMini.answer" :id="'mini_radio_b_' + itemMini.id" type="radio" class="radio-group" value="B" @change="changeQuestion(item, 'question__' + item.num, indexMini, false)" />
                                                    <label :for="'mini_radio_b_' + itemMini.id" v-html="itemMini.optionB"></label>
                                                </p>
                                                <p v-if="itemMini.optionC" class="radio_ja_p">
                                                    <input v-model="itemMini.answer" :id="'mini_radio_c_' + itemMini.id" type="radio" class="radio-group" value="C" @change="changeQuestion(item, 'question__' + item.num, indexMini, false)" />
                                                    <label :for="'mini_radio_c_' + itemMini.id" v-html="itemMini.optionC"> </label>
                                                </p>
                                                <p v-if="itemMini.optionD" class="radio_ja_p">
                                                    <input v-model="itemMini.answer" :id="'mini_radio_d_' + itemMini.id" type="radio" class="radio-group" value="D" @change="changeQuestion(item, 'question__' + item.num, indexMini, false)" />
                                                    <label :for="'mini_radio_d_' + itemMini.id" v-html="itemMini.optionD"></label>
                                                </p>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="content_bottom" v-if="!typeFull">
                    <!-- Btn: previous -->
                    <div class="btn-item" @click="previous()">
                        <img v-if="num == 1" src="/static/images/back-den.png" alt="previous">
                        <img v-if="num > 1" src="/static/images/icon-back.png" alt="previous">
                        <span :class="[{'color-active': num > 1}]">{{$t('task_result.prev')}}</span>
                    </div>

                    <!-- Btn: next -->
                    <div class="btn-item xoay" @click="next()">
                        <img v-if="num == questions.length" src="/static/images/back-den.png" alt="next">
                        <img v-if="num < questions.length" src="/static/images/icon-back.png" alt="next">
                        <span :class="[{'color-active': num < questions.length}]">{{$t('task_result.next')}}</span>
                    </div>
                </div>
            </div>

            <!-- Exam status -->
            <div class="status__exam">
                <div class="top">
                    <!-- Exam: time -->
                    <div class="timeQuestion" :class="{time__out: time <= 60}">{{timeMemaining}}</div>
                </div>

                <!-- Number answers -->
                <div class="count__answer">
                    <span class="lb"><b>{{$t('new.title15')}}:</b></span>
                    <span class="txt"><b>{{questionsAnswered.length}}/{{questions.length}}</b></span>
                </div>

                <!-- List question -->
                <div class="ds_quesion_png" id="scrollAnwser">
                    <template v-for="(item, index) in questions">
                        <a type="button" class="circle__question" @click="changeQuestion(item, 'question__' + item.num, null, true)" :class="[{isCommit: item.commitFlag}, {activeQuesion: item.id == activeID}]" name="button" :key="index">
                            {{item.numStr}}
                        </a>
                    </template>
                </div>

                <!-- Title preview -->
                <div class="count__answer">
                    <span class="lb"><b>{{$t('new.title126')}}:</b></span>
                    <span class="txt"><b>{{questionsChecked.length}}/{{questions.length}}</b></span>
                </div>

                <!-- List preview -->
                <div class="ds_quesion_png" id="scrollAnwserChecked">
                    <template v-for="(item, index) in questions">
                        <a type="button" class="circle__question" v-if="item.checkFlag == 1" @click="changeQuestion(item, 'question__' + item.num, null, true)" :class="[{isCommit: item.commitFlag}, {activeQuesion: item.id == activeID}]" name="button" :key="index">
                            {{item.numStr}}
                        </a>
                    </template>
                </div>

                <!-- Toogle mode -->
                <div class="toogleType">
                    <button @click="toogleType()">{{ typeFull ? $t("examBegins.notFull") : $t("examBegins.full") }}</button>
                    <!-- Btn: commit exam -->
                    <button @click="preCommit()" class="btn-commit">{{ $t("task_answer.examCommit") }}</button>
                </div>
            </div>
        </div>

        <!-- Loading -->
        <loading :showLoading="loading" />
    </div>
</template>

<script>
    import { mapState, mapMutations } from "vuex";
    import loading from "@/components/loading/loading";
    export default {
        data() {
            return {
                loading: false,
                activeID: null,
                preID: null,
                time: 0,
                num: 1,
                timeRemaining: 0,
                timeMemaining: 0,
                spendTime: 0,
                answered: 0,
                exam: {
                    id: null,
                    courseId: null,
                    courseName: null,
                },
                questions: [],
                typeFull: true
            };
        },
        props: {
            data: {
                type: Object,
                default: {},
            }
        },
        components: {
            loading,
        },
        created() {
            this.init();
        },
        mounted() {
            const self = this;

            // Calc time
            setInterval(() => {
                self.time = self.time - 1;
            }, 1000);

            document.body.addEventListener('keydown', event => {
                // ArrowLeft
                if (event.key == 'ArrowLeft') {
                    event.preventDefault();
                }

                // ArrowRight
                if (event.key == 'ArrowRight') {
                    event.preventDefault();
                }

                // ArrowDown
                if (event.key == 'ArrowDown') {
                    event.preventDefault();
                }

                // ArrowDown
                if (event.key == 'ArrowDown') {
                    event.preventDefault();
                }
            })

        },
        computed: {
            // Get questions answered
            questionsAnswered () {
                return this.questions.filter((x) => x.commitFlag == 1);
            },

            // Get questions answered
            questionsChecked () {
                return this.questions.filter((x) => x.checkFlag == 1);
            },

            ...mapState({
                preQuestions: (state) => state.exam.preQuestions
            }),
        },
        watch: {
            // Get time left to do homework
            time(newValue) {
                this.timeMemaining = this.formatTime(newValue);

                // Commit answer
                if (newValue == 0) {

                    this.commit();

                    // Time off
                    this.$alert(window.vm.$i18n.t("js.examOver"), "", {
                        confirmButtonText: window.vm.$i18n.t("js.confirm"),
                        callback: () => {}
                    });
                } else {
                    if (Number.isInteger(newValue/60)) {
                        // Save answer
                        this.save();
                    }
                }
            },

            // Question action
            activeID (newID) {
                if (newID != null) {
                    
                    // Get question
                    let data = this.questions.filter(item => item.id == newID);
                    this.num = data[0].num;

                    // Save answer
                    this.save();
                }
            }
        },
        methods: {
            
            init: async function () {

                // Load data exam
                this.exam.id = this.data.examId;
                this.exam.courseId = this.data.courseId;
                this.exam.courseName = this.data.courseName;
                
                // Get data exam
                let data = await this.getDataExam({ examId: this.exam.id, courseId: this.exam.courseId });

                // Get all question
                let questions = [];

                // All time
                this.timeRemaining = data.time + data.spendTime;

                // Get time and spend time
                let spendTime = 0;
                let time = 0;

                // Check storage
                let prevExam = localStorage.getItem(`exam_${this.checkExam(this.exam.id, this.exam.courseId)}`);
                
                if (prevExam != null) {
                    
                    let results = JSON.parse(prevExam);
                    // Get all questions form storage
                    questions = results.questions;

                    // Get spend time form storage
                    spendTime = results.spendTime;
                    time = this.timeRemaining - spendTime;
                } else {
                    // Get all questions form storage
                    questions = data.questions;

                    // Get spend time form storage
                    spendTime = data.spendTime;
                    time = this.timeRemaining - spendTime;
                }

                // Get all question
                this.questions = questions;

                // Get time
                this.time = time;

                // Type show
                this.typeFull = this.data.type == 1 ? true : false;

                // Set active question
                this.activeID = this.questions[0].id;
                this.preID = this.questions[0].id;

                // Disable loading
                this.loading = false;
            },

            ...mapMutations("exam", ["setPreQuestions"]),

            // Scroll question
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
                // Save answer
                this.save();
            },

            previous: function () {
                let num = this.num - 1;
                let key = this.questions.findIndex(item => item.num == num);

                if (key >= 0) {
                    this.changeQuestion(this.questions[key], 'question__' + this.questions[key].num, null, true);
                }
            },

            next: function () {
                let num = this.num + 1;
                let key = this.questions.findIndex(item => item.num == num);

                if (key >= 0) {
                    this.changeQuestion(this.questions[key], 'question__' + this.questions[key].num, null, true);
                }
            },

            // Toogle mode show
            toogleType: function () {
                this.typeFull = !this.typeFull;

                this.preID = this.activeID;

                // Save answer
                this.save();

                // Save vuex
                this.setPreQuestions(this.questions);
            },

            // Get data exam
            getDataExam: function (data) {
                const self = this;
                // console.log(data.courseId)
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/studyCourseQuestion/getScheduleExamQuestionsByCourseId", {
                            examId: data.examId,
                            courseId: data.courseId,
                            languageType: this.$lang()
                        })
                        .then((response) => {

                            // Convert list questions
                            let questions = self.convertDataQuesions(response.data.questions);

                            resolve({ questions: questions, time: parseInt(response.data.examTime), spendTime: parseInt(response.data.spendTime) });
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            // Convert data
            convertDataQuesions: function (data) {
                const self = this;
                const questions = data.reduce((item, value) => {

                    let answer = value.commitAnswer == "" ? null : value.commitAnswer;

                    // Create variable
                    let question = {
                        id: value.questionId,
                        type: parseInt(value.questionTypeId),
                        typeName: value.questionTypeName,
                        num: parseInt(value.questionNum),
                        numStr: self.convertPageNumber(parseInt(value.questionNum)),
                        score: parseInt(value.questionScore),
                        audioPath: value.audioPath,
                        audioName: value.audioName,
                        content: self.convertData(null, value.questionContent),
                        anlysis: value.questionAnalysis,
                        commitFlag: 0,
                        checkFlag: 0,
                        currentAnswer: "",
                        answer: answer,
                        optionA: self.convertData("A", value.optionA),
                        optionB: self.convertData("B", value.optionB),
                        optionC: self.convertData("C", value.optionC),
                        optionD: self.convertData("D", value.optionD),
                        optionE: self.convertData("E", value.optionE),
                        optionF: self.convertData("F", value.optionF),
                        optionG: self.convertData("G", value.optionG),
                        optionH: self.convertData("H", value.optionH),
                        optionI: self.convertData("I", value.optionI),
                        optionJ: self.convertData("J", value.optionJ),
                        miniQuestions: []
                    };

                    question.commitFlag = answer != null ? 1 : 0;

                    // Type: 1 - radio
                    if (parseInt(question.type) == 1) {
                        question.answer = answer;
                    }

                    // Type: 2 - check box
                    if (parseInt(question.type) == 2) {
                        question.answer = answer != null ? answer.split(",") : [];
                    }

                    // Type: 3 - text area
                    if (parseInt(question.type) == 3) {
                        question.answer = answer;
                    }

                    // Type: 4 - paragraph
                    if (parseInt(question.type) == 4) {

                        question.answer = answer;

                        const miniQuestions = value.subQuestionList.reduce((a, v) => {

                            let miniAnswer = v.commitAnswer == "" ? null : v.commitAnswer;

                            let miniQuestion = {
                                id: v.questionId,
                                type: parseInt(v.questionTypeId),
                                typeName: v.questionTypeName,
                                num: parseInt(v.questionNum),
                                numStr: self.convertPageNumber(parseInt(value.questionNum)),
                                score: parseInt(v.questionScore),
                                audioPath: v.audioPath,
                                audioName: v.audioName,
                                content: self.convertData(null, v.questionContent),
                                anlysis: v.questionAnalysis,
                                commitFlag: 0,
                                currentAnswer: "",
                                answer: miniAnswer,
                                optionA: self.convertData("A", v.optionA),
                                optionB: self.convertData("B", v.optionB),
                                optionC: self.convertData("C", v.optionC),
                                optionD: self.convertData("D", v.optionD),
                                optionE: self.convertData("E", v.optionE),
                                optionF: self.convertData("F", v.optionF),
                                optionG: self.convertData("G", v.optionG),
                                optionH: self.convertData("H", v.optionH),
                                optionI: self.convertData("I", v.optionI),
                                optionJ: self.convertData("J", v.optionJ),
                                miniQuestions: []
                            };

                            miniQuestion.commitFlag = miniAnswer != null ? 1 : 0;

                            a.push(miniQuestion);
                            return a;
                        }, []);

                        let miniAnsweredList = miniQuestions.filter((x) => x.commitFlag == 0);
                        question.commitFlag = miniAnsweredList.length ? 0 : 1;

                        question.miniQuestions = miniQuestions;
                    }

                    // Check flag
                    if (self.preQuestions.length) {
                        let keyFlag = self.preQuestions.findIndex(item => item.id == question.id);
                        if (keyFlag >= 0) {
                            question.checkFlag = self.preQuestions[keyFlag].checkFlag;
                        }
                    }

                    // Add
                    item.push(question);
                    return item;
                }, []);

                return questions;
            },

            // Convert content
            convertData: function (name, str) {
                let question = "";

                if (name != null && str != null && str != "") {
                    let tag = this.findTagInString(str);
                    question = `<${tag.tagName} style="${tag.style || ""};color: black !important;">${name + ".&nbsp;"}</${tag.tagName}><div class="html__custom">${str.replace(/&nbsp;/g, "")}</div>`;
                }

                if (name == null && str != null && str != "") {
                    question = str.replace(/&nbsp;/g, "");
                }

                return question;
            },

            // Convertv page number
            convertPageNumber: function (number) {
                if (number.toString().length != 1) {
                    return `${number}`;
                }
                return `0${number}`;
            },

            preCommit: function () {

                // Save answer
                this.save();

                let unfinished = this.questions.some(item => item.commitFlag == 0);

                let msg = window.vm.$i18n.t("js.submitConfirmTest");
                msg = this.exam.id != null ? window.vm.$i18n.t("js.submitConfirmExam") : msg;

                // Kiểm tra đã làm đủ câu hỏi
                msg = unfinished ? window.vm.$i18n.t("new.title42") : msg;

                let comfirm = `${this.$t('new.title15')}: ${this.questionsAnswered.length}/${this.questions.length}`;

                this.$confirm(msg, comfirm, {
                    confirmButtonText: window.vm.$i18n.t("js.confirm"),
                    cancelButtonText: window.vm.$i18n.t("js.cancel"),
                    cancelButtonClass: "btn-custom-cancel",
                })
                .then(() => {
                    this.commit();
                })
                .catch(() => {});
            },

            // Change question
            changeQuestion: function (item, id, indexMini, scroll) {
                this.preID = this.activeID;
                this.activeID = item.id;

                const self = this;
                
                setTimeout(function () {
                    let key = self.questions.findIndex(item => item.id == self.activeID);

                    if (key >= 0) {

                        if (self.questions[key].type != 4) {
                            let answer = self.questions[key].answer == "" ? null : self.questions[key].answer;
                            self.questions[key].commitFlag = answer != null ? 1 : 0;
                        } else {
                            if (indexMini != null) {
                                let answer = self.questions[key].miniQuestions[indexMini].answer == "" ? null : self.questions[key].miniQuestions[indexMini].answer;
                                self.questions[key].miniQuestions[indexMini].commitFlag = answer != null ? 1 : 0;

                                let stts = self.questions[key].miniQuestions.filter((x) => x.commitFlag == 0);
                                self.questions[key].commitFlag = stts.length ? 0 : 1;
                            }
                        }
                    }

                    // Scroll
                    if (scroll) {
                        self.scrollToElement(id);
                    }
                }, 100);
            },

            // Commit answer
            commit: async function () {
                let answers = [];

                let spendTime = this.spendTime + (this.timeRemaining - this.time);
                
                let isCongratulation = this.questions.some(item => item.type == 3);

                // Request
                let params = {
                    courseId: this.exam.courseId,
                    examId: this.exam.id,
                    spendTime: spendTime,
                    answers: [],
                    isCommitExam: true,
                    isCommit: 1
                };

                this.questions.forEach((item, i) => {

                    let miniAnswers = [];
                    let commitAnswer = item.answer;

                    // Type: 1 - Radio
                    if (item.type == 1) {
                        commitAnswer = commitAnswer == null ? "" : commitAnswer;
                    }

                    // Type: 2 - checkBox
                    if (item.type == 2) {
                        commitAnswer = commitAnswer == null ? "" : commitAnswer.join(",");
                    }

                    // Type: 3 - Text area
                    if (item.type == 3) {
                        commitAnswer = commitAnswer == null ? "" : commitAnswer;
                    }

                    // Type: 4 - Paragraph
                    if (item.type == 4) {
                        commitAnswer = commitAnswer == null ? "" : commitAnswer;
                        const miniAnswersClid = item.miniQuestions.reduce((a, v) => {
                            let currentAnswerClid = v.answer == null ? "" : v.answer;

                            let miniAnswer = {
                                commitAnswer: currentAnswerClid,
                                questionAnswer: v.currentAnswer,
                                questionId: v.id,
                                questionNum: v.num,
                                questionScore: v.score,
                                questionTypeId: v.type,
                                subQuestionAnswers: [],
                            };

                            a.push(miniAnswer);

                            return a;
                        }, []);

                        miniAnswers = miniAnswersClid;

                    }
                    

                    answers.push({
                        commitAnswer: commitAnswer,
                        questionAnswer: item.currentAnswer,
                        questionId: item.id,
                        questionNum: item.num,
                        questionScore: item.score,
                        questionTypeId: item.type,
                        subQuestionAnswers: miniAnswers
                    });
                });

                params.answers = answers;

                // Commit answer
                await this.commitAnswer(params);

                // Msg: success
                let msg = window.vm.$i18n.t("js.submitSuccessTest");
                msg = this.exam.id != null ? window.vm.$i18n.t("js.submitSuccessExam") : msg;
                this.$el_alert_type(msg, "success");

                //  Finished
                this.$router.push({
                    path: "/home/scheduleCongratulation",
                    query: {
                        outlineInfo: JSON.stringify({
                            courseId: this.exam.courseId,
                            courseName: this.exam.courseName,
                            examId: this.exam.id,
                            isCongratulation: isCongratulation
                        }),
                    },
                });
            },

            // Check content empty
            checkedEmpty: function (str) {
                let status = false;

                if (str != undefined && str != null && str != "") {
                    status = true;
                }

                return status;
            },

            // Check content video
            checkedVideo: function (str) {
                let status = false;

                if (!this.checkedEmpty(str)) {
                    status = false;
                } else {
                    if ("mp4" == str.substring(str.lastIndexOf(".") + 1)) {
                        status = true;
                    }
                }

                return status;
            },

            // Check content audio
            checkedAudio: function (str) {
                let status = false;

                if (!this.checkedEmpty(str)) {
                    status = false;
                } else {
                    if ("mp3" == str.substring(str.lastIndexOf(".") + 1)) {
                        status = true;
                    }
                }

                return status;
            },

            // Save answser
            save: async function () {

                if (this.preID == null) return;

                let spendTime = this.spendTime + (this.timeRemaining - this.time);

                let key = this.questions.findIndex(item => item.id == this.preID);

                let questionPrev = this.questions[key];

                let commitAnswer = questionPrev.answer;

                let miniAnswers = [];


                // Type: 1 - Radio
                if (questionPrev.type == 1) {
                    commitAnswer = commitAnswer == null ? "" : commitAnswer;
                }

                // Type: 2 - checkBox
                if (questionPrev.type == 2) {
                    commitAnswer = commitAnswer == null ? "" : commitAnswer.join(",");
                }

                // Type: 3 - Text area
                if (questionPrev.type == 3) {
                    commitAnswer = commitAnswer == null ? "" : commitAnswer;
                }

                // Type: 4 - Paragraph
                if (questionPrev.type == 4) {
                    commitAnswer = commitAnswer == null ? "" : commitAnswer;
                    const miniAnswersClid = questionPrev.miniQuestions.reduce((a, v) => {
                        let currentAnswerClid = v.answer == null ? "" : v.answer;

                        let miniAnswer = {
                            commitAnswer: currentAnswerClid,
                            questionAnswer: v.currentAnswer,
                            questionId: v.id,
                            questionNum: v.num,
                            questionScore: v.score,
                            questionTypeId: v.type,
                            subQuestionAnswers: [],
                        };

                        a.push(miniAnswer);

                        return a;
                    }, []);

                    miniAnswers = miniAnswersClid;

                }

                // Request
                let params = {
                    courseId: this.exam.courseId,
                    examId: this.exam.id,
                    spendTime: spendTime,
                    isCommit: 0,
                    isCommitExam: true,
                    answers: [],
                };


                let answer = {
                    commitAnswer: commitAnswer,
                    questionAnswer: questionPrev.currentAnswer,
                    questionId: questionPrev.id,
                    questionNum: questionPrev.num,
                    questionScore: questionPrev.score,
                    questionTypeId: questionPrev.type,
                    subQuestionAnswers: miniAnswers
                };

                let answers = [];

                answers.push(answer);

                params.answers = answers;

                // Save answer
                if (this.timeRemaining == this.time) {
                    // console.log(`start time: ${this.time}`);
                    this.time = this.time - 1;
                    params.spendTime = 1;
                    await this.saveExamAnswer(params);
                }

                // Save localstorage
                spendTime = this.timeRemaining - this.time;
                let exam = {
                    spendTime: spendTime,
                    questions: this.questions
                }
                localStorage.setItem(`exam_${this.checkExam(this.exam.id, this.exam.courseId)}`, JSON.stringify(exam));

                // Reset spendTime
                this.spendTime = spendTime;
            },

            // Comit answer
            commitAnswer: function (params) {
                const self = this;
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/studyCourseQuestion/commitScheduleExam", params)
                        .then((response) => {
                            localStorage.removeItem(`exam_${self.checkExam(self.exam.id, self.exam.courseId)}`);
                            resolve(response.data);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            // Save answer
            saveExamAnswer: function (params) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/studyCourseQuestion/saveScheduleExamAnswer", params)
                        .then((response) => {
                            resolve(response.data);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            // Format time
            formatTime: function (time) {

                if (time == undefined || time == null) {
                    return `00:00:00`;
                }

                if (time <= 0) {
                    time = -1 * time;
                }

                let h;
                let m;
                let s;

                h = Math.floor(time / 3600);
                m = Math.floor(time / 60) - 60 * h;
                s = time % 60;

                h = h < 10 ? "0" + h : h;
                m = m < 10 ? "0" + m : m;
                s = s < 10 ? "0" + s : s;

                return `${h}:${m}:${s}`;
            },
        },
    };
</script>

<style scoped>
    .prt {
        position: relative;
    }
    .content__exam_t {
        height: calc(100% - 60px);
        overflow: auto;
    }
    .content_bottom {
        width: 100%;
        height: 60px;
        display: flex;
        flex-flow: row;
        justify-content: space-evenly;
        align-items: center;
    }
    .content_bottom .btn-item {
        width: 26%;
        text-align: center;
        cursor: pointer;
    }
    .content_bottom .btn-item img {
        width: 40px;
        height: 40px;
        margin: auto;
    }
    input::-webkit-input-placeholder, textarea::-webkit-input-placeholder {
        color: #bdc3c7; opacity:1;
    }
    input:-moz-placeholder, textarea:-moz-placeholder {
        color: #bdc3c7; opacity:1;
    }
    input::-moz-placeholder, textarea::-moz-placeholder {
        color: #bdc3c7; opacity:1;
    }
    input:-ms-input-placeholder, textarea:-ms-input-placeholder {
        color: #bdc3c7; opacity:1;
    }
    .toogleType {
        margin-top: 10px;
        width: 100%;
        display: flex;
    }
    .toogleType button.btn-commit {
        color: #ffffff;
        background-color: #2c980d;
        border-color: #2c980d;
        margin-left: 4%;
    }
    .toogleType button.btn-commit:hover {
        color: #ffffff;
        background-color: #2c980d;
        border-color: #2c980d;
        margin-left: 4%;
    }
    .toogleType button {
        width: 48%;
        padding: 15px 5px;
        font-size: 14px;
        font-weight: 700;
        color: black;
        background-color: transparent;
        border: 2px solid #0071c5;
        border-radius: 5px;
        transition: ease 0.5s;
    }
    .toogleType button:hover {
        color: white;
        background-color: #0071c5;
    }
    .content__answer__radio, .content__answer__check__box {
        margin-top: 5px;
    }
    .radio_ja, .radio_ja .content__answer__radio {
        margin-top: 10px !important;
    }
    .radio_ja_p {
        margin-bottom: 0 !important;
    }
    .nd__u {
        min-height: 40px;
        white-space: break-spaces;
    }
    .container__ {
        position: fixed;
        height: 100vh;
        width: 100%;
        top: 0;
        background-color: #ffffff;
        z-index: 999;
        left: 0;
    }
    .time__out {
        color: #ff4757;
    }
    .content__answer__radio p,
    .content__answer__check__box p {
        margin-bottom: 10px;
    }
    .exam__page {
        width: 100%;
        display: flex;
        max-width: 1200px;
        margin: 10px auto;
    }
    .content__exam {
        max-height: calc(100vh - 20px);
        overflow: auto;
        background: #ffffff;
        margin: 0 10px 0 0;
        flex: 75%;
        scroll-behavior: smooth;
    }
    .content__exam .question__ {
        padding: 1%;
    }
    .question__brd._isCommit {
        background-color: #1e90ff !important;
    }
    .content__exam .question__ .question__brd {
        padding: 5px;
        position: relative;
        height: 38px;
        transition: ease 0.5s;
        border-radius: 10px;
        background-color: #bdc3c7;
    }
    .content__exam .question__ .question__brd.activeQuesion .question__count span {
        color:#ff4757 !important;
    }
    .content__exam .question__ .question__brd .question__count {
        margin-top: 5px;
        transition: ease 0.5s;
    }
    .content__exam .question__ .question__brd .question__count span {
        color: #ffffff;
        font-size: 18px;
        font-weight: 700;
        margin-left: 5px;
        transition: ease 0.5s;
    }
    .content__exam .question__ .question__brd.activeQuesion .question__count span {
        color: #ffffff;
    }
    .content__exam .question__ .question__brd.activeQuesion .question__end span {
        color: #ffffff;
    }
    .question__content {
        padding-left: 12px;
        padding-top: 6px;
    }
    .content__exam .question__ .question__brd .question__content {
        flex: 85%;
    }
    .question__end {
        position: absolute;
        right: 10px;
        top: 5px;
        align-items: center;
        display: flex;
        transition: ease 0.5s;
    }
    .question__end span{
        margin-right: 5px;
        font-weight: 700;
        color: #ffffff;
    }
    .status__exam {
        height: max-content;
        background: #fff;
        flex: 25%;
        padding: 1%;
        max-height: calc(100vh - 20px);
    }
    .status__exam .top {
        display: flex;
        align-items: center;
    }
    .status__exam .top .btn__commit {
        flex: 30%;
        text-align: right;
        text-align: -webkit-right;
    }
    .status__exam .top .btn__commit img {
        transition: ease 0.5s;
        width: 46px;
        cursor: pointer;
    }
    .status__exam .top .btn__commit img:hover {
        transform: scale(1.15);
    }
    .status__exam .count__answer {
        margin-top: 10px;
        display: flex;
    }
    .status__exam .ds_quesion_png {
        display: flex;
        flex-wrap: wrap;
        margin-top: 10px;
        max-height: calc(34vh - 25px);
        overflow: auto;
    }
    .status__exam .ds_quesion_png_preview_questions {
        max-height: calc(20vh - 5px) !important;
    }
    .status__exam .ds_quesion_png .circle__question {
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        margin: 2px;
        min-width: auto;
        line-height: 1;
        white-space: nowrap;
        cursor: pointer;
        background: #fff;
        border: 1px solid #dcdfe6;
        color: #606266;
        -webkit-appearance: none;
        text-align: center;
        box-sizing: border-box;
        outline: 0;
        transition: 0.1s;
        font-weight: 500;
        font-size: 14px;
        text-decoration: none;
    }
    .status__exam .ds_quesion_png .circle__question:hover {
        color: #ffffff;
        background-color: #a4b0be;
    }
    .status__exam .ds_quesion_png .circle__question.isCommit {
        background-color: #1e90ff;
        color: #ffffff !important;
    }
    .status__exam .ds_quesion_png .circle__question.activeQuesion {
        border-color: #ff4757;
        border-width: 2px;
        color: #000000;
    }
    .status__exam .count__answer span.lb {
        flex: 70%;
        color: #1e90ff;
        font-size: 14px;
    }
    .status__exam .count__answer span.txt {
        flex: 70%;
        text-align: right;
        color: #2f3542;
        font-size: 14px;
    }
    .status__exam .top .timeQuestion {
        border: 2px solid #a4b0be;
        border-radius: 5px;
        line-height: 1;
        text-align: center;
        padding: 5px 20px;
        font-size: xx-large;
        flex: 70%;
    }
    .content__exam,
    .status__exam {
        border-radius: 10px;
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
    }
    /* Scroll */
    #scrolla::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        background-color: #f5f5f5;
        border-radius: 10px;
    }

    #scrolla::-webkit-scrollbar {
        width: 10px;
        background-color: #ffffff;
        border-radius: 0 10px 10px 0;
    }

    #scrolla::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-image: -webkit-gradient(linear, left bottom, left top, color-stop(0.44, rgb(112, 161, 155)), color-stop(0.72, rgb(30, 144, 255)), color-stop(0.86, rgb(30, 144, 255)));
    }
    #scroll::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        background-color: #f5f5f5;
        border-radius: 10px;
    }

    #scroll::-webkit-scrollbar {
        width: 10px;
        background-color: #ffffff;
        border-radius: 0 10px 10px 0;
    }

    #scroll::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-image: -webkit-gradient(linear, left bottom, left top, color-stop(0.44, rgb(112, 161, 155)), color-stop(0.72, rgb(30, 144, 255)), color-stop(0.86, rgb(30, 144, 255)));
    }
    #scrollAnwser::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-image: -webkit-gradient(linear, left bottom, left top, color-stop(0.44, rgb(112, 161, 155)), color-stop(0.72, rgb(30, 144, 255)), color-stop(0.86, rgb(30, 144, 255)));
    }
    #scrollAnwserChecked::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-image: -webkit-gradient(linear, left bottom, left top, color-stop(0.44, rgb(112, 161, 155)), color-stop(0.72, rgb(30, 144, 255)), color-stop(0.86, rgb(30, 144, 255)));
    }

    /* Radio */
    [type="radio"]:checked,
    [type="radio"]:not(:checked) {
        position: absolute;
        left: -9999px;
    }
    [type="radio"]:checked + label,
    [type="radio"]:not(:checked) + label {
        position: relative;
        padding-left: 28px;
        cursor: pointer;
        line-height: 20px;
        display: inline-flex;
        /* color: #666; */
        width: auto;
    }
    [type="radio"]:checked + label:before,
    [type="radio"]:not(:checked) + label:before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 18px;
        height: 18px;
        border: 1px solid #151414;
        border-radius: 100%;
        background: #fff;
    }
    [type="radio"]:checked + label:after,
    [type="radio"]:not(:checked) + label:after {
        content: "";
        width: 10px;
        height: 10px;
        background: #1e90ff;
        position: absolute;
        top: 5px;
        left: 5px;
        border-radius: 100%;
        -webkit-transition: all 0.2s ease;
        transition: all 0.2s ease;
    }
    [type="radio"]:not(:checked) + label:after {
        opacity: 0;
        -webkit-transform: scale(0);
        transform: scale(0);
    }
    [type="radio"]:checked + label:after {
        opacity: 1;
        -webkit-transform: scale(1);
        transform: scale(1);
    }
    /* Checkbox */
    [type="checkbox"]:checked,
    [type="checkbox"]:not(:checked) {
        position: absolute;
        left: -9999px;
    }
    [type="checkbox"]:checked + label,
    [type="checkbox"]:not(:checked) + label {
        position: relative;
        padding-left: 28px;
        cursor: pointer;
        line-height: 20px;
        display: inline-flex;
        /* color: #666; */
        width: auto;
    }
    [type="checkbox"]:checked + label:before,
    [type="checkbox"]:not(:checked) + label:before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 18px;
        height: 18px;
        border: 1px solid #151414;
        border-radius: 30%;
        background: #fff;
    }
    [type="checkbox"]:checked + label:after,
    [type="checkbox"]:not(:checked) + label:after {
        content: "";
        width: 10px;
        height: 10px;
        background: #1e90ff;
        position: absolute;
        top: 5px;
        left: 5px;
        border-radius: 30%;
        -webkit-transition: all 0.2s ease;
        transition: all 0.2s ease;
    }
    [type="checkbox"]:not(:checked) + label:after {
        opacity: 0;
        -webkit-transform: scale(0);
        transform: scale(0);
    }
    [type="checkbox"]:checked + label:after {
        opacity: 1;
        -webkit-transform: scale(1);
        transform: scale(1);
    }
    /* Textarea */
    textarea {
        font-family: arial!important;
        text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.004) !important;
        text-rendering: optimizeLegibility !important;
        -webkit-font-smoothing: antialiased !important;
        box-sizing: border-box !important;
        border: 0 !important;
        border-bottom: 2px solid #1e90ff !important;
        margin: 0 !important;
        padding: 12px 0 !important;
        resize: none !important;
        font-size: 14px !important;
        line-height: 1 !important;
        width: 100% !important;
        max-width: calc(100% - 5px) !important;
        min-height: calc(12px + 1.618em) !important;
        color: #161616 !important;
        transition: ease 0.4s !important;
        height: 44px !important;
    }

    textarea:focus {
        outline: none !important;
        background-color: #fafafa !important;
        height: 160px !important;
        border: none !important;
        border-bottom: 2px solid #1e90ff !important;
    }
    .questions_preview_rigth {
        margin-top: 0px;
        flex: 4%;
    }
    .preview_question {
        width: 28px;
        height: 28px;
        margin: auto;
        cursor: pointer;
    }
    .check_review_active {
        color: #fff;
        background: #1e90ff;
    }
</style>



// WEBPACK FOOTER //
// src/components/schedule/full.vue